import dayjs from "dayjs";

/**
 * get viewer status based on lastActiveTime
 * @param {Date} lastAt
 */
const minuteDifference = 1;

export const getViewerStatusMinuteDiff = () => {
  return minuteDifference;
};

export const getViewerUpdatedAtMinuteDiff = () => {
  return +process.env.REACT_APP_TRAFFIC_LIGHT_MINUTE_GRACE_PERIOD || 2;
};

export const getViewerStatus = (lastAt) => {
  const beforeDate = dayjs();
  const compareDate = beforeDate.diff(lastAt, "m", true);

  let isActive = false;
  if (compareDate <= minuteDifference && lastAt) isActive = true;

  return isActive;
};

export const getViewerTrafficStatus = (lastAt) => {
  const trafficMinuteUpdate =
    +process.env.REACT_APP_TRAFFIC_LIGHT_MINUTE_GRACE_PERIOD || 2;
  const beforeDate = dayjs();
  const compareDate = beforeDate.diff(lastAt, "m", true);

  let isActive = false;
  if (compareDate <= trafficMinuteUpdate && lastAt) isActive = true;

  return isActive;
};

export const sortViewerActiveAt = (viewers) => {
  return viewers.sort(function compare(a, b) {
    if (new Date(a.activeAt) > new Date(b.activeAt)) {
      return -1;
    }
    if (new Date(a.activeAt) < new Date(b.activeAt)) {
      return 1;
    }
    return 0;
  });
};
